import { Component, inject, Optional } from '@angular/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { ContractLayoutComponent } from '../../../layouts/contract-layout/contract-layout.component';
import { PlatformService } from '../../../core/services/platform.service';
import { InjectionToken } from '@angular/core';
import type { Response } from 'express';
import { SEOService } from '../../../core/services/seo.service';

const RESPONSE = new InjectionToken<Response>('RESPONSE');

@Component({
  selector: 'app-error-404',
  // standalone: false,
  templateUrl: './error-404.component.html',
  styleUrl: './error-404.component.scss',
  imports: [ContractLayoutComponent, InlineSVGModule],
})
export class Error404Component {
  max = 5;
  min = 1;
  svgName = `errors/404/404-${Math.floor(Math.random() * (this.max - this.min + 1) + this.min)}.svg`;
  constructor(private pt: PlatformService, private seoService: SEOService) {
    if (pt.isServer) {
      var response = inject(RESPONSE, { optional: true });
      if (response) {
        response.sendStatus(404);
      }
    }
    this.seoService.setDisallowRobots();
  }
}
